import ObservationCardGridView from "@/components/observations/ObservationCardGridView";
import { useFeatureTypeName } from "@/hooks/useFeatureTypeName";
import type { LayoutContext } from "@/lib/models";
import { featureCreateObservationUrlBuilder } from "@/lib/url-builder";
import { Observation, ObservationService } from "@/services/ObservationService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const FeatureTypeObservationListPage: React.FC = () => {
  const [observations, setActionsList] = useState<Observation[]>([]);
  const params = useParams();
  const { featureTypeName } = useFeatureTypeName(params.featureTypeId!);
  const { setPageName } = useOutletContext<LayoutContext>();

  const getName = (name: string | null) => {
    return name ? `Feature Type: ${name}` : 'Observations';
  }

    useEffect(() => {
      setPageName(getName(featureTypeName));
    }, [featureTypeName, setPageName]);

  useEffect(() => {
    
    ObservationService
      .getByFeatureTypeId(params.featureTypeId!)
      .then(setActionsList);
  }, [params.featureTypeId]);

  return (
    <div className="container mx-auto p-4">
      <ObservationCardGridView observations={observations} pageTitle={getName(featureTypeName)} createObservationUrl={featureCreateObservationUrlBuilder(params.siteId!, params.featureId!)} />
    </div>
  );
};

export default FeatureTypeObservationListPage;
